import React, { useEffect, useState, useContext, Fragment } from "react";
import SharedDataContext from "../../_helper/SharedData";
import PackagesTable from "./PackagesTable";
import {
    showAlert,
} from "../../Services/Shared.service";
import { Breadcrumbs, Btn, H6 } from "../../AbstractElements";
import { Row, Col, Card, CardBody, Container, Modal, ModalBody, Nav, NavItem, NavLink } from "reactstrap";
import { getPackage, getPackageRate, getPackagesList, getPackagesListByFilter, getPackagesListBySearch } from "../../Services/Packages.service";
import { Plus } from "react-feather";
import PackageInput from "./PackageInput";
import PackageRateInput from "../PackageRates/PackageRateInput";
import SearchTable from "../Common/Component/SearchTable";
import CustomizerContext from "../../_helper/Customizer";
import { packageFilterColumns } from "../../Data/Configuration/Packages";
import SelectedFilter from "../TripManagement/BookingHistory/SelectedFilter";
import FilterTable from "../Common/Component/FilterTable";
const Packages = () => {
    const { cityData, globalCityField, setShowApiLoader } =
        useContext(SharedDataContext);
    const [tableData, setTableData] = useState([]);
    const [loader, setLoader] = useState(false);
    const [pagination, setPagination] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [paginationTotalRows, setPaginationTotalRows] = useState(0);
    const [isOpen, setIsOpen] = useState(false)
    const [editId, setEditId] = useState("")
    const [searchData, setSearchData] = useState("");
    const [filterType, setFilterType] = useState("");
    const [filterData, setFilterData] = useState([]);
    const { mix_background_layout } = useContext(CustomizerContext)

    const onChangePage = (page) => {
        console.log("page", page);
        setPagination(page - 1);
    };

    const onChangeRowsPerPage = (currentRowsPerPage) => {
        setRowsPerPage(currentRowsPerPage);
    };

    useEffect(() => {
        fetchTableData();
    }, [globalCityField.value, pagination, rowsPerPage]);

    const fetchTableData = () => {
        const serviceCityId = globalCityField.value?.id || null;
        if (filterData.length == 0 && !searchData) {
            let obj = {
                isPagination: true,
                serviceCityId: serviceCityId,
                page: pagination,
                size: rowsPerPage,
            };
            setLoader(true);
            getPackagesList(obj)
                .then((result) => {
                    setPaginationTotalRows(result.data.count);
                    setTableData(result.data.list);
                    disableLoaders();
                })
                .catch((err) => {
                    disableLoaders();
                    showAlert("error", err.response?.data?.message
                        ? err.response.data.message : "Something went wrong");
                });
        } else if (filterData.length > 0 && filterType == "filter") {
            let obj = {
                serviceCityId: serviceCityId,
                page: pagination,
                size: rowsPerPage,
            };
            filterData.forEach((d)=>{
                obj[d.column_name] = d["values"][0]
            })
            setLoader(true);
            getPackagesListByFilter(obj)
                .then((result) => {
                    setPaginationTotalRows(result.data.count);
                    setTableData(result.data.searchResponse);
                    disableLoaders();
                })
                .catch((err) => {
                    disableLoaders();
                    showAlert("error", err.response?.data?.message
                        ? err.response.data.message : "Something went wrong");
                });
        } else if (searchData && filterType == "search") {
            let obj = {
                serviceCityId: serviceCityId,
                name: searchData,
                page: pagination,
                size: rowsPerPage,
            };
            setLoader(true);
            getPackagesListBySearch(obj)
                .then((result) => {
                    setPaginationTotalRows(result.data.count);
                    setTableData(result.data.list);
                    disableLoaders();
                })
                .catch((err) => {
                    disableLoaders();
                    showAlert("error", err.response?.data?.message
                        ? err.response.data.message : "Something went wrong");
                });
        }
    };
    const disableLoaders = () => {
        setLoader(false);
        // setShowApiLoader(false);
    };

    let columns = [];
    packageFilterColumns.map((element) => {
        if (element.value) {
            columns.push({
                value: {
                    name: element.name,
                    value: element.value,
                    type: element.type,
                },
                label: element.name,
            });
        }
    });

    const onEditClick = (obj) => {
        setIsOpen(!isOpen)
        setEditId(obj.id)
    }

    useEffect(() => {
        if (!searchData && filterType != "search") return;
        setPagination(0)
        fetchTableData();
    }, [searchData]);

    useEffect(() => {
        if (filterData.length == 0 && filterType != "filter") return;
        setPagination(0)
        fetchTableData();
    }, [filterData]);

    const toggleModal = () => {
        fetchTableData()
        setEditId("")
        setIsOpen(!isOpen)
    }

    const removeFilter = (index) => {
        const newfilterData = [...filterData];
        newfilterData.splice(index, 1);
        setFilterData(newfilterData);
    };

    return (
        <Fragment>
            <Breadcrumbs
                parent="Configuration"
                subParent="Packages"
                mainTitle="Packages"
                // span1={
                //     <Btn attrBtn={{ style: { display: "flex", padding: "7px 14px", justifyContent: "center", alignItems: "center" }, onClick: (e) => setIsOpen(true) }}>
                //         <Plus size={"18px"} style={{ marginRight: "5px" }} /> Add
                //     </Btn>
                // }
                span3={
                    <SearchTable
                        searchData={searchData}
                        setSearchData={setSearchData}
                        setFilterData={setFilterData}
                        setFilterType={setFilterType}
                    />
                }
                span2={
                    <FilterTable
                        options={columns}
                        setFilterData={setFilterData}
                        filterData={filterData}
                        setSearchData={setSearchData}
                        setFilterType={setFilterType}
                    />
                }
            />
            <Container fluid={true} className="datatables">
                <Row className="selected-filter">
                    {filterData.map((element, i) => {
                        return (
                            <SelectedFilter
                                key={i}
                                element={element}
                                index={i}
                                removeFilter={removeFilter}
                            />
                        );
                    })}
                </Row>
                <Row>
                    <Col sm="12">
                        <Card>
                            <CardBody className="p-0">
                                <PackagesTable
                                    fetchTableData={fetchTableData}
                                    tableData={tableData}
                                    setShowApiLoader={setLoader}
                                    onChangePage={onChangePage}
                                    paginationPerPage={rowsPerPage}
                                    paginationTotalRows={paginationTotalRows}
                                    onChangeRowsPerPage={onChangeRowsPerPage}
                                    onEditClick={onEditClick}
                                    loader={loader}
                                />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
            <PackageInput cityData={cityData} editId={editId} isOpen={isOpen} toggleModal={toggleModal} />
        </Fragment>
    );
};

export default Packages;
